import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from "axios";
import "./styles.css";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import ClanProfil from '../pages/ClanProfil';
import HunterReport from './HunterReport';

import MyComponent from '../components/MyComponent';
import LampControl from '../components/LampControl';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'tipalarma', label: 'Tip alarma', alignRight: false },
  { id: 'opis', label: 'Opis', alignRight: false },
  { id: 'vrsta', label: 'Vrsta', alignRight: false },
  { id: 'severity', label: 'Severity', alignRight: false },
  { id: 'lokacija', label: 'Lokacija', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'vrijeme alarma', label: 'Vrijeme alarma', alignRight: false },
  { id: 'firma', label: 'Firma ', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (field === 'ime')
      return filter(array, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'prezime')
      return filter(array, (_user) => _user.prezime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'maticnibrojlovca')
      return filter(array, (_user) => _user.maticnibrojlovca.indexOf(query) !== -1);

    if (field === 'adresa')
      return filter(array, (_user) => _user.adresa.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'telefon')
      return filter(array, (_user) => _user.telefon.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'huntingclubId')
      return filter(array, (_user) => _user.huntingclub.naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'datumpolaganja')
      return filter(array, (_user) => _user.datumpolaganja.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'vrstaclanstva')
      return filter(array, (_user) => _user.vrstaclanstva.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'lovackilist')
      return filter(array, (_user) => _user.lovackilist.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1);
}

export default function ReportsListAll() {

  const [hunterid, setHunterId] = useState('');
  const [showbuildingcreate, setShowBuildingCreate] = useState('');
  const [huntingclub, setHuntingClub] = useState('');
  const [loading, setLoading] = useState(false);
  const [showreport, setShowReport] = useState(false);
  const [id, setId] = useState('');
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [members, setMembers] = useState([]);
  const [hunter, setHunter] = useState('');
  const [izabran, setIzabran] = useState('');
  const [dataloaded, setDataLoaded] = useState(false);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [checked, setChecked] = useState(true);
  const forceUpdate = useForceUpdate();
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const handleChange = (event, id) => {
    var array = members;
    const objectWithSpecificId = array.find(
      obj => obj.id === id
    );
    axios.put("https://biserna.maticnaknjiga.com:3000/api/streetlamps/" + id,
      {
        "clanskupstine": !objectWithSpecificId.clanskupstine
      }
    ).then(() => {
      objectWithSpecificId.clanskupstine = !objectWithSpecificId.clanskupstine;
      setMembers(array);
      forceUpdate();
    });
  };

  const handleChangeLovackiList = (event, id) => {
    var array = members;
    const objectWithSpecificId = array.find(
      obj => obj.id === id
    );
    axios.put("https://biserna.maticnaknjiga.com:3000/api/hunters/" + id,
      {
        "lovackilist": !objectWithSpecificId.lovackilist
      }
    ).then(() => {
      objectWithSpecificId.lovackilist = !objectWithSpecificId.lovackilist;
      setMembers(array);
      forceUpdate();
    });
  };

  useEffect(() => {
    if (!dataloaded) {
      getAllHunters();
      const role = currentUser.roles[0];
      const rolenumber = role.slice(10);
    }
  });

  const getAllHunters = async () => {
    try {
      const response = await axios.get(SERVER_URL + "/alarms");
      await setMembers(response.data);
      setDataLoaded(true);
    } catch (err) {
      console.log("error");
    }
  };

  const getHuntingClub = async (huntingclubid) => {
    try {
      const response = await axios.get("https://biserna.maticnaknjiga.com:3000/api/huntingclubs/" + huntingclubid);
      setHuntingClub(response.data);
    } catch (err) {
      console.log("error");
    }
  };

  const getHunter = async (hunterid) => {
    try {
      const response = await axios.get("https://biserna.maticnaknjiga.com:3000/api/hunters/" + hunterid);
      setHunter(response.data);
      setShowReport(!showreport);
    } catch (err) {
      console.log("error");
    }
  };

  const handleRefresh = (event, id) => {
    setShowBuildingCreate(!showbuildingcreate);
    getAllHunters();
  };

  const handleOn = (event, hunterid) => { };
  const handleOff = (event, hunterid) => { };

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    if (newSelected.length !== 0) {
      getHunter(id);
    }
  };

  const handleClickShow = (event, id) => {
    setHunterId(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;
  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName, orderBy);
  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Pametna rasvjeta </title>
      </Helmet>

      <Container maxWidth={false} sx={{ backgroundColor: '#001B44', minHeight: '100vh', padding: '20px', borderRadius: '0px' }}>
        <Typography 
        sx={{
          color: '#ffffff',
          fontSize: '1.3rem',
          fontWeight: 600,
          mb: 2
        }}>
          Pregled alarma
        </Typography>

        <Card sx={{ backgroundColor: '#001B44', color: '#001B44' }}>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={(e) => setFilterName(e.target.value)}
            sx={{ color: '#ffffff' }}
          />

          <Scrollbar>
            <TableContainer sx={{ width: '100%' }}> {/* �irina 100% */}
              <Table sx={{ width: '100%', tableLayout: 'fixed', color: '#001B44' }}> {/* tableLayout: fixed da kolone budu ravnomjerne */}
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={members.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  sx={{
                    '& .MuiTableCell-head': {
                      backgroundColor: '#001B44',  // plava pozadina
                      color: '#ffffff',            // bijeli tekst
                      fontWeight: 'bold',          // podebljani tekst
                    }
                  }}
                />

                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { name, description, type, priority, zone, isActive, lastTriggered, maintenanceCompany, id } = row;
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser} sx={{ backgroundColor: '#001B44', color: '#ffffff' }}>
                        <TableCell component="th" scope="row" sx={{ color: '#001B44' }}>
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={name} src={name} />
                          </Stack>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{name}</Typography>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{description}</Typography>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{type}</Typography>
                        </TableCell>

                        <TableCell align="left"
                          sx={{
                            color:
                              priority === 'Critical' ? '#ff1744' :
                                priority === 'High' ? '#FFA500' :
                                  priority === 'Medium' ? '#ffeb3b' :
                                    priority === 'Low' ? '#4CAF50' :
                                      priority === 'Info' ? '#9E9E9E' :
                                        '#ffffff'
                          }}
                        >
                          <Typography variant="subtitle2" noWrap>{priority}</Typography>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{zone}</Typography>
                        </TableCell>

                        <TableCell align="left"
                          sx={{
                            color:
                              isActive === true ? '#ff1744' :
                                isActive === 'High' ? '#FFA500' :
                                  isActive === 'Medium' ? '#ffeb3b' :
                                    isActive === 'Low' ? '#4CAF50' :
                                      isActive === false ? '#9E9E9E' :
                                        '#ffffff'
                          }}
                        >
                          <Typography variant="subtitle2" noWrap>{isActive ? 'Aktivan' : 'Neaktivan'}</Typography>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{lastTriggered ? new Date(lastTriggered).toLocaleString() : 'N/A'}</Typography>
                        </TableCell>

                        <TableCell align="left" sx={{ color: '#ffffff' }}>
                          <Typography variant="subtitle2" noWrap>{maintenanceCompany}</Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={TABLE_HEAD.length} /> {/* prilagodeno da pokrije sve kolone */}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>


          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, p) => setPage(p)}
            onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            sx={{ color: '#ffffff', backgroundColor: '#001B44' }}
          />
        </Card>
      </Container>
    </>
  );
}
